<div [formGroup]="periodoForm">
  <mat-form-field class="full-with">
    <mat-label>{{'general.lbl_periodo_academico_min' | translate}}</mat-label>
    <span matPrefix> <mat-icon> assignment</mat-icon>
    </span>
    <input matInput readonly="true" placeholder="{{
        'general.lbl_periodo_academico_min' |
        translate }}" formControlName="periodoAcademico" name="periodoAcademico" />
    <button color="primary" matSuffix mat-icon-button aria-label="Clear" (click)="verPeriodo()"
      matTooltip="{{'general.lbl_periodo_academico_min'|translate}}">
      <mat-icon>search</mat-icon>
    </button>
    <mat-error *ngIf="periodoForm.controls.periodoAcademico.invalid ">{{
      'general.val_campo_requerido' | translate
      }}</mat-error>
  </mat-form-field>
</div>
